import { jsx as _jsx } from "react/jsx-runtime";
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import { getIsUngatedForSeats } from 'pricing-pages-lib/utils/gatingUtils';
import { FullPriceContainerBlockLarge, MicroCopy, PerMonth } from 'pricing-pages-ui/components/common/pricing/HighlightedPriceDisplay';
import PriceDisplay from 'pricing-pages-ui/components/common/pricing/PriceDisplay';
import { useSelector } from 'react-redux';
import { activeCurrencySelector } from '../../../selectors/CurrencySelectors';
import { usePricingLibSelector } from '../../../selectors/SelectorUtils';

const HighlightedFreePriceDisplay = ({
  perMonth = true
}) => {
  const isSeatsRedesignUngated = usePricingLibSelector(getIsUngatedForSeats);
  const currencyCode = useSelector(activeCurrencySelector);
  return /*#__PURE__*/_jsx(FormattedJSXMessage, {
    message: perMonth ? isSeatsRedesignUngated ? 'merchCards.pricing.pricingPerMonthFreeNoSubtext_jsx' : 'merchCards.pricing.pricingPerMonthFree_jsx' : isSeatsRedesignUngated ? 'merchCards.pricing.pricingForeverFreeNoSubtext_jsx' : 'merchCards.pricing.pricingForeverFree_jsx',
    options: {
      currencyCode,
      price: 0,
      seleniumId: 'free-highlighted-price-per-month'
    },
    elements: {
      MicroCopy,
      PriceContainer: FullPriceContainerBlockLarge,
      PriceDisplay,
      PerMonth
    }
  });
};

export default HighlightedFreePriceDisplay;